import { render, staticRenderFns } from "./ShareFriend.vue?vue&type=template&id=8dc051a2&scoped=true"
import script from "./ShareFriend.vue?vue&type=script&lang=js"
export * from "./ShareFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc051a2",
  null
  
)

export default component.exports